import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  selectHasSubdomainBeenChecked,
  selectCustomSubdomain,
} from 'src/app/root-store/root.selectors';

@Component({
  selector: 'app-auth-dashboard',
  templateUrl: './auth-dashboard.component.html',
  styleUrls: ['./auth-dashboard.component.scss'],
})
export class AuthDashboardComponent implements OnInit {
  selectCustomSubdomain$: Observable<string>;
  showSamlAuth$: Observable<boolean>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.checkForSamlLogin();
  }

  private checkForSamlLogin(): void {
    const hasSubdomainBeenChecked$ = this.store.pipe(
      select(selectHasSubdomainBeenChecked),
    );
    this.selectCustomSubdomain$ = this.store.pipe(
      select(selectCustomSubdomain),
    );

    this.showSamlAuth$ = combineLatest([
      hasSubdomainBeenChecked$,
      this.selectCustomSubdomain$,
    ]).pipe(
      map(
        ([subdomainChecked, customSubdomain]) =>
          subdomainChecked && customSubdomain !== '',
      ),
    );
  }
}
